import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { StyledButton, ButtonContainer, Container as StyledContainer } from '../pages/Questionnaire/styles';

export default function ChapterEndView({ payload, onNext }) {
  const { testName, chapterIndex } = payload;
  return (
    <StyledContainer style={{ zIndex: 500 }}>
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h4" align="center" gutterBottom>
          הפרק נגמר
        </Typography>

        {typeof chapterIndex === 'number' ? <Typography variant="body1" align="center" style={{ direction: "rtl" }} paragraph>
          סיימת את פרק {chapterIndex + 1} במבחן ״{testName}״
        </Typography> : null}
      </Box>

      <ButtonContainer style={{ justifyContent: 'center', marginTop: 'auto' }}>
        <StyledButton variant="contained" onClick={() => onNext()}>
          המשך לפרק הבא
        </StyledButton>
      </ButtonContainer>
    </StyledContainer>
  );
}
